import { Modal } from "antd";
import { ICExclamationCircleOutlined } from "components/list/ListIcon";

const { confirm } = Modal;

const ModalConfirm = (props) => {
  const {
    okText = "Ya Hapus",
    width = 600,
    okButtonProps,
    customMessage,
    message,
    cancelText = "Batalkan",
  } = props;
  const messageModal = customMessage || <p className="mb-0">{message}</p>;
  return confirm({
    ...props,
    icon: <ICExclamationCircleOutlined />,
    content: messageModal,
    centered: true,
    okText: okText,
    okButtonProps: { ...okButtonProps },
    autoFocusButton: null,
    cancelText: cancelText,
    width: width,
  });
};

export default ModalConfirm;
